import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';
import { industries } from '../data/site';

const Industries = () => {
  return (
    <div className="industries-page page-shell">
      <section className="industries-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Industries</span>
          <h1>
            Outcomes built around the <span className="gradient-text serif-accent">realities of your industry.</span>
          </h1>
          <p>
            We work where the business problem is hardest — regulated, real-time, data-intensive and
            operationally critical. Eleven industry practices, all senior, all shipping.
          </p>
          <div className="hero-actions" style={{ marginTop: 26 }}>
            <Link to="/case-studies" className="btn-light btn-arrow">View outcomes</Link>
            <Link to="/request-demo" className="btn-ghost btn-arrow">Talk to a partner</Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <div className="industries-list">
            {industries.map((ind) => (
              <article className="industry-detail-card professional-card" key={ind.id}>
                <img src={ind.image} alt={ind.name} />
                <div className="industry-detail-body">
                  <span className="eyebrow-tag">{ind.name.split(' ')[0]}</span>
                  <h3>{ind.name}</h3>
                  <p>{ind.summary}</p>
                  <div className="industry-detail-grid">
                    <div>
                      <h4>Common Challenges</h4>
                      <ul>{ind.challenges.map((c) => (<li key={c}>{c}</li>))}</ul>
                    </div>
                    <div>
                      <h4>Outcomes Delivered</h4>
                      <ul>{ind.outcomes.map((o) => (<li key={o}>{o}</li>))}</ul>
                    </div>
                  </div>
                  <Link to={`/industries/${ind.id}`} className="learn-more">Explore industry →</Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="industries-cta">
        <div className="site-container-wide professional-card">
          <h2>Want to see how we work in your industry?</h2>
          <p>Tell us your industry and your goal. We will share a tailored briefing within 48 hours.</p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary-large">Request briefing</Link>
            <Link to="/case-studies" className="btn-outline btn-arrow">All case studies</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
